/* API Service for FindAMortgageBroker.com Preferences */
import apiClient from '../api-client';

export default {
	getFambSettings(userId) {
		return apiClient('v2').get(`/Famb/GetFambUserPreference?userId=${userId}`);
	},
	saveFambSettings(settingsInfo) {
		return apiClient('v2').post('/Famb/SaveFambUserPreference', {
			...settingsInfo,
		});
	},
	checkProfileURLValidity({ profileSlug, signal, userId = null }) {
		const endpoint = '/Famb/GetFambUrl';

		return apiClient('v2').post(endpoint, {
			signal,
			userId,
			fambUrl: profileSlug,
		});
	},
};
